import React, { Component } from 'react'
import CountUp from "react-countup";
import { fabric } from "fabric";
import * as _ from 'lodash-joins'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import CS from "../../../commons/services/Common";
import MS from "../../../commons/services/Moment";
import AS from "../../Login/Service/Authentication";
import PS from "../../PlantList/MonitoringApiService";
import axios from 'axios';
import styled from 'styled-components';
import StatusButton from '../../../commons/components/button/StatusButton';
import ToggleSwitch from '../../../commons/components/input/ToggleSwitch';
import SolarBasicInfo from '../../../commons/components/infoCard/SolarBasicInfo';
import SolarInfo from '../../../commons/components/infoCard/SolarInfo';
import { Message, MessageBox } from "element-react";
import fireVector from "../../../assets/images/icon/fire-vector.svg";
import { withTranslation } from 'react-i18next';
import AutoFitText from '../../../commons/components/text/AutoFitText';
import {DetailV2InverterCurrentPowerCard, DetailV2IssueInputLabel, DetailV2PannelInfoCardWidth, DetailV2SelectedPannelInfoWidth} from './translationUiconst'; 

var SCALE_FACTOR = 1;
var TEMPLATE_WIDTH = 600;
var TEMPLATE_HEIGHT = 500;

class DetailV2 extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      plantInfo: { // 발전소 정보
        plantId: props.match.params.plantId,
        name: this.props.history.location.state?.title || "",
        address: this.props.history.location.state?.projectAddr || "",
        installationCapacity: 0,
        invs: null,
        operationStartDt: "",
        constructorId: null,
      },
      accumulationPower: this.props.history.location.state?.accumulationPower || 0,
      moduleInfo: {
        moduleInfos: [], // 모듈 정보
        moduleSerialNos: [], // 모듈 시리얼 번호
        modulesGroupbyString: [], // 모듈 정보 그룹화 (인버터별 그룹 및 하위 모듈 정렬)
        statusInfos: [], // 모듈 상태 정보
        joinResultGroup: [], // 상태값이 추가된 모듈 정보 그룹화 (인버터별 그룹 및 하위 모듈 정렬)
        selectedModule: {} // 선택된 모듈 정보
      },
      inverterSerialNos: [], // 인버터 시리얼 번호
      inverters: [], // 인버터 정보
      activeInverterSerialNo: "", // 활성화된 인버터의 시리얼 번호와 일치하는 모듈만 보여주기 위한 상태값
      canvas: {},
      cst: {}
    };
    this.canvas = null;
    this.setInterval = null;
  }

  componentDidMount() {
    this.buildCanvas();
    this.getPlantInfo();
    this.getModuleInfos();
    this.refresh();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevSelected = prevState.moduleInfo.selectedModule;
    const currSelected = this.state.moduleInfo.selectedModule;
  
    if (prevSelected !== currSelected) {
      if (currSelected.currentTitle) {
        if (prevSelected?.currentTitle) {
          this.canvas._objects.forEach(obj => {
            if (obj.type === "module" && obj.title === prevSelected.currentTitle) {
              const rect = obj.getObjects('rect')[0];
              let batchType = obj.batchType || "row";
              let width = batchType === "row" ? 15 : 30;
              let height = batchType === "row" ? 30 : 15;
              rect.set({
                width,
                height,
                stroke: null,
                strokeWidth: 0
              });
            }
          });
        }
    
        // 현재 선택 모듈의 테두리 추가
        if (currSelected?.currentTitle) {
          this.canvas._objects.forEach(obj => {
            if (obj.type === "module" && obj.title === currSelected.currentTitle) {
              const rect = obj.getObjects('rect')[0];
              let strokeWidth = 2;
              let batchType = obj.batchType || "row";
              let width = (batchType === "row" ? 15 : 30) - strokeWidth;
              let height = (batchType === "row" ? 30 : 15) - strokeWidth;
              rect.set({
                width,
                height,
                stroke: 'blue',
                strokeWidth
              });
            }
          });
        }
      }
      this.canvas.requestRenderAll();
    }
  }

  componentWillUnmount() {
    if (this.setInterval) {
      clearInterval(this.setInterval);
    }
  }

  async refresh () {
    this.setInterval = setInterval(() => {

      // this.getModuleInfos();
      this.getModuleStatus();
      this.getRealtimePower(this.state.inverterSerialNos);
    },30 * 1000);
  }

  async getPlantInfo() {
    let { plantInfo, inverterSerialNos } = this.state;
    const { plantId } = plantInfo;
    
    if (inverterSerialNos.length == 0) {
      try {
        const { data } = await axios.get(
          `/usr/api/user-plant/info?plantIds=${plantId}`
        );
        const { data: equipRes} = await axios.get(
          `/cst/api/constructor-plant/equipment/${plantId}`
        );
        
        plantInfo = data[0]; // 발전소 정보 최신화
        const costructorId = plantInfo.constructorId;

        const plantInfos = AS.getLoggedInPlantInfos();
        let filteredPlantInfo = plantInfos.filter(v => v.id == plantId);

        // inverterSerialNos = CS.getKeyValues(filteredPlantInfo[0].invs, "serialNo"); // 인버터 시리얼 번호 추출
        inverterSerialNos = CS.getKeyValues(equipRes, "inverterNo"); // equipRes에서 인버터 시리얼 번호 추출

        plantInfo.invs = filteredPlantInfo;
        plantInfo.constructorId = costructorId;
        plantInfo.operationStartDt = MS.format(plantInfo.operationStartDt, "YYYY년 M월 D일"); // 운영 시작일

        let cst = await axios.get(`/cst/api/constructor/${costructorId}`);

        this.setState({
          inverterSerialNos: inverterSerialNos,
          plantInfo: plantInfo,
          cst: cst.data
        })

        this.getRealtimePower(inverterSerialNos);
      } catch (error) {
        console.error(error);
      }
    }
  }
  
  getModuleInfos = async () => {
    try {
      const { plantId } = this.state.plantInfo;
      const res = await axios.get(`/cst/api/constructor-plant/equipment/${plantId}`);

      // s: inv모듈의 위치정보를 위해 가져오고 equipment 모듈정보에 join
      const resInv = await axios.get(
        `/usr/api/constructor-plant/inverter/${plantId}`
      );
      const invModuleInfo = [];
      if (resInv?.data && Array.isArray(resInv.data)) {
        resInv.data.forEach(data => {
          const { modules } = data;
          if (modules) {
            const objectInfo = JSON.parse(modules);
            if (Array.isArray(objectInfo)) {
              invModuleInfo.push(...objectInfo);
            }
          }
        });
      }
      if (invModuleInfo.length > 0) {

      }
      // e: inv모듈의 위치정보를 위해 가져오고 equipment 모듈정보에 join
      if (!res.data || !Array.isArray(res.data)) {
        console.error('Invalid response data:', res.data);
        return;
      }
  
      const modulesGroupByString = [];
      let moduleInfos = [];
      let zigbees = [];
  
      res.data.forEach(data => {
        
        const { inverterNo } = data;
        try {
          const stringInfo = JSON.parse(data.stringInfo);
  
          if (Array.isArray(stringInfo)) {
            stringInfo.forEach(info => {
              const { children: modules, title: stringId } = info;

              const mergedModules = _.sortedMergeLeftOuterJoin(
                modules,
                "zigbee",
                invModuleInfo,
                "moduleSerialNo"
              )
              this.buildModules(inverterNo, mergedModules);

              modulesGroupByString.push({ stringId, mergedModules });
              moduleInfos = [...moduleInfos, ...mergedModules];
              zigbees = [...zigbees, ...CS.getKeyValues(mergedModules, 'zigbee')];
            });
          } else {
            console.warn('Invalid stringInfo format:', stringInfo);
          }
        } catch (err) {
          console.error('Failed to parse stringInfo:', data.stringInfo, err);
        }
      });
  
      const moduleInfo = {
        moduleInfos,
        modulesGroupByString,
        moduleSerialNos: zigbees,
      };
      
      this.setState({ moduleInfo: { ...this.state.moduleInfo, ...moduleInfo } });

      this.getModuleStatus();
    } catch (error) {
      console.error('Failed to fetch module info:', error);
    }
  };

  async getModuleStatus() {
    try {
      const { moduleInfos, moduleSerialNos } = this.state.moduleInfo;
      const plantId = this.state.plantInfo.plantId;
      // console.log('Module serial numbers:', moduleSerialNos);
      let status = await PS.getLatestModuleList({ moduleSerialNos }, plantId);
      // let status = await getMOCK_MODULE_DATA();
      const joinResult = _.sortedMergeLeftOuterJoin(moduleInfos, "zigbee", status, "_id");
      this.joinModulesData(joinResult);
      this.setState({ moduleInfo: { ...this.state.moduleInfo, statusInfos: status ?? [] } });

      let outputPowerAvg = 0;
      if (status.length > 0) {
          let limitSize = Math.floor(status.length *0.2);
          limitSize = limitSize == 0 ? 1 : limitSize;
          let outputPowers = CS.getKeyValues(status, 'outputPower');
          outputPowers.sort((a,b)=>b-a);
          // outputPowers = CS.sortDesc(outputPowers.map(v => { return v * -1 }));
          outputPowerAvg = CS.calcSplitArrayAvg(outputPowers, 0, limitSize)
      }

      this.setState({
        moduleInfo: {
          ...this.state.moduleInfo,
          outputPowerAvg
        }
      })

      let inputCurrentArr = [];
      status.some( v => {
          inputCurrentArr.push(Math.abs(v.inputCurrent*-1));
      });
      let minInputCurrent = Math.min.apply(null, inputCurrentArr);

      let increament = 0;
      status.some( v => {
          // increament = increament + ( (v.outputPower*-1) - (v.inputVoltage * minInputCurrent));
          increament = increament + ( (v.outputPower) - (v.inputVoltage * minInputCurrent));
      });

      this.setState({
          increament: (increament/1000).toFixed(2)
      });

      let color;
      this.canvas._objects.some(v => {
          if (v.type == "module") {
              color = "#1c1c1c";
              const index = status.findIndex((e) => {
                  return e._id === v.zigbee;
              });
              if (index >= 0) {
                  const rate = Math.abs(Math.round(( (status[index].outputPower * -1)/outputPowerAvg ) * 100));
                  // const rate = Math.round(( (status[index].outputPower)/outputPowerAvg ) * 100);
                  const state = status[index].state;
                  if (rate >= 75) {
                      color = "#ff65cc";
                  } else if (rate >= 50 && rate < 75) {
                      color = "#d63bff";
                  } else if (rate >= 25 && rate < 50) {
                      color = "#a55bff";
                  } else {
                      color = "#5d129f";
                  }
                  // if (state != 30) {
                  //   color = "#5d129f";
                  // }
                  v._objects[0].set('rate', rate);
              } 
              v._objects[0].set('fill', color);
          }
      });
      // console.log("canvas object:", this.canvas._objects);
      this.canvas.renderAll();
    } catch (error) {
      console.error("canvas error: ", error);
    }
  }

  // status 값과 join된 데이터를 합쳐서 상태값을 추가 후 그룹화
  joinModulesData = (joinResult) => {
    joinResult.some( (v,i) => {
        if (v._id !== undefined) {
            joinResult[i].status = (v.inputPower * -1 < 0 || v.outputPower * -1 < 0) ? "state-error" : "stage-on";
        } else {
            joinResult[i].status = "state-off";
            joinResult[i].inputCurrent = 0;
            joinResult[i].inputVoltage = 0;
            joinResult[i].inputPower = 0;
            joinResult[i].outputCurrent = 0;
            joinResult[i].outputVoltage = 0;
            joinResult[i].outputPower = 0;
        }
        //joinResult[i].isLowerThanAvg = (v.powerStageTemp < avgs[`avg` + avgIdx]);
    });
    
    const joinResultGroup = _.chain(joinResult)
        .groupBy(v => {
            let titleArr = v.title.split(".");
            return `${titleArr[0]}.${titleArr[1]}`
        })
        .map(
            (modules, stringId) => ({
                stringId: Number(stringId),
                inverterIdx: stringId.split(".")[0],
                stringIdx: stringId.split(".")[1],
                modules: modules.sort((a, b) => {
                    let aT = parseInt(a.title.split(".")[2]);
                    let bT = parseInt(b.title.split(".")[2]);
                    return aT - bT;
                })
            })
        )
        .orderBy(
            ['stringId'], ['asc']
        )
        .value();

    this.setState({
      moduleInfo: {
        ...this.state.moduleInfo,
        joinResultGroup: joinResultGroup
    }});
  }

  // 인버터별 모듈 그리기
  buildModules = (inverterNo, modules) => {
    let rect, text, group, canvasInfo;



    modules.some( (v, idx) => {
        let batchType = v.batchType || "row";
        let width = batchType === "row" ? 15 : 30;
        let height = batchType === "row" ? 30 : 15;

        rect = new fabric.Rect({
            width: width,
            height: height,
            fill: '#FFFFFF'
        });
        text = new fabric.Text(v.title, {
            visible: false,
            fontSize: 0
        });
        canvasInfo = v.canvasInfo;

        group = new fabric.Group([ rect, text ], {
            type: "module",
            title: v.title,
            zigbee: v.zigbee,
            inverterNo: inverterNo,
            left: v?.leftX,
            top: v?.topY,
            lockMovementX: true,
            lockMovementY: true,
            angle: v.azimuth,
            hasControls: false,
            draggable: false,
            batchType: batchType,
        });

        this.canvas.add(group);
        // group.on("mouseover", function(e) {
        //     // popover(true, e, this.title, this.zigbee);
        // });
      group.on("mouseover", function(e) {

          // console.log('Selected module:', this.title);
          popover(true, e, this.title, this.zigbee);
        })
        // group.on("mouseout", function(e) {
        //     // popover(false, e, "", "");
        // });
        const popover = (isShow, e, title, zigbee) => {
            let receivedTime;
            let inputCurrent = 0;
            let inputVoltage = 0;
            let inputPower = 0;
            let outputCurrent = 0;
            let outputVoltage = 0
            let outputPower = 0;
            let rate = e.target._objects[0]?.rate || 0;
            let caseTemp = 0;
            let powerStageTemp = 0;

            if (isShow) {
                this.state.moduleInfo.statusInfos.some(v => {
                    if (v._id == zigbee) {
                        //let power = v.power;
                        receivedTime = v.time;
                        inputCurrent = Math.abs(v.inputCurrent*-1);
                        inputVoltage = Math.abs(v.inputVoltage);
                        inputPower = Math.abs(v.inputPower*-1);
                        outputCurrent = Math.abs(v.outputCurrent*-1);
                        outputVoltage = Math.abs(v.outputVoltage);
                        outputPower = Math.abs(v.outputPower*-1);
                        caseTemp = v.caseTemp;
                        powerStageTemp = v.powerStageTemp;
                        return true;
                    }
                });
                const newSelectedModule = {
                  currentTitle: title,
                  receivedTime: receivedTime,
                  inputPower: inputPower,
                  inputVoltage: inputVoltage,
                  inputCurrent: inputCurrent,
                  outputPower: outputPower,
                  outputVoltage: outputVoltage,
                  outputCurrent: outputCurrent,
                  rate: rate,
                  caseTemp: caseTemp,
                  powerStageTemp: powerStageTemp
                }
                
                this.setState({
                  moduleInfo: {
                    ...this.state.moduleInfo,
                    selectedModule: newSelectedModule
                  }
                })
            }
        }
    });
  }

  // 실시간 인버터 출력 조회
  getRealtimePower = async(inverterSerialNos) => {
    const param = { "inverterSerialNos": inverterSerialNos }
    try {
      const inverters = await PS.getLatestInverter(param);
      this.settingInverterData(inverters);
    } catch (error) {
      this.settingInverterData([]); 
    }
  }

  settingInverterData = (list) => {
    const inverters = [];
    let totalPvCurrent = 0, totalRCurrent = 0, totalSCurrent = 0, totalTCurrent = 0, totalAccumulationPower = 0;
    list.some((v, i) => {
        totalPvCurrent += v.pvCurrent;
        totalRCurrent += v.lineRCurrent;
        totalSCurrent += v.lineSCurrent;
        totalTCurrent += v.lineTCurrent;
    });
    /*
    if (list.length > 1) {
        inverters.push(
            {
              _id: "",
              pvCurrent: totalPvCurrent,
              rCurrent: totalRCurrent,
              sCurrent: totalSCurrent,
              tCurrent: totalTCurrent,
            }
        );
    }
    */
    if (list.length > 0) inverters.push(...list);

    this.setState({
        inverters: inverters
    });
  }

  buildCanvas() {
    this.canvas = this.__canvas = new fabric.Canvas("c");
    this.canvas.selection = false;
  }


  // 인버터 선택 시 물리적 레이아웃 모듈 필터링
  handleActiveModulesByInverter = (id) => {
    if (!this.canvas || !this.canvas._objects) return 
    
    this.setState({
      activeInverterSerialNo: id
    })
    this.canvas._objects.some(v => {
        v._objects[0].group.visible = id === "" || (v.inverterNo === id);
    });
    this.canvas.renderAll();
  };

  render() {
    const { plantInfo, inverters, activeInverterSerialNo, moduleInfo, cst, name, accumulationPower } = this.state;
    const { selectedModule, statusInfos, joinResultGroup } = moduleInfo;
    const { t, i18n } = this.props;
    return (
      <>
        <div className="page-tit gray">
          <div className="container location">
            <h2 className="tit">{t('key128')}</h2>
            <span>
              <strong
                style={{
                  display: "inline-block",
                  fontWeight: "normal",
                  opacity: 0.6,
                }}
              >
                {/* 발전소 상세정보 */}
                {t("key541")}
              </strong>
            </span>
            <span>
              <strong>{t('key143')}</strong>
            </span>
          </div>
        </div>
        <section className="pt-25 pb-45 current-issue">
          <div className="container">
            <PlantInfoCard plantInfo={plantInfo} title={plantInfo.name} projectAddr={plantInfo.address} accumulationPower={accumulationPower} t={t} i18n={i18n}/>
            <Divider />
            {/* <ItemContainer gridFr={"1fr"}>
              <RsdMonitoring />
            </ItemContainer> */}
            {/* <Divider /> */}
            {/* AI정보 */}
            {/* <ItemContainer gridFr={"1fr"}>
              <AiInfo />
            </ItemContainer>
            <Divider /> */}
            <ItemContainer gridFr={"1fr 1fr"}>
              <StatusLineGraphCard t={t} /> 
              <PannelInfo selectedModule={selectedModule} t={t} i18n={i18n}/>
            </ItemContainer>
            <ItemContainer gridFr={"1fr"}>
              <ModuleCanvasCard canvas={this.canvas} t={t}/>
              {/* S: 현장 화면 */}
              {/* <TitleWrapper>
                <h4>현장 화면</h4>
                <div style={{ width: "100%", backgroundColor: "gray", height: "100%", borderRadius: "12px"}} />
              </TitleWrapper> */}
              {/* E: 현장 화면 */}
            </ItemContainer>
            <Divider />
            <ItemContainer gridFr={"1fr"}>
              <ElectricCircuit joinResultGroup={joinResultGroup} selectedModule={selectedModule} t={t} i18n={i18n}/>
            </ItemContainer>
            <Divider />
            <ItemContainer gridFr={"1fr"}>
              <InverterCurrentPowerCard 
                inverters={inverters} 
                activeInverterSerialNo={activeInverterSerialNo}
                handleActiveModulesByInverter={this.handleActiveModulesByInverter}
                t={t}
                i18n={i18n}
              />
            </ItemContainer>
            <Divider />
            <ItemContainer gridFr={"1fr"}>
              <IssueInfo t={t} i18n={i18n} />
            </ItemContainer>
            <Divider />
            <ItemContainer gridFr={"1fr"}>
              <SolarBasicInfo 
                operationStartDt={plantInfo.operationStartDt}
                diff={plantInfo.diff}
                ownerName={cst.ownerName}
              />
            </ItemContainer>
            <Divider />
            <ItemContainer gridFr={"1fr"}>
              <SolarInfo 
                installationCnt={plantInfo.installationCnt}
                installationCapacity={plantInfo.installationCapacity}
                moduleCnt={plantInfo.moduleCnt}
              />
            </ItemContainer>
          </div>
        </section>
      </>
    );
  }
}


class PlantInfoCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plantInfo: {
        name: this.props.title || "",
        installationCapacity: "",
      },
      projectAddr: this.props?.projectAddr || "",
      cst: {
        constructorName: "",
        contactNum: "",
      },
    }
  }

  async componentDidUpdate() {
    if (this.state.plantInfo !== this.props.plantInfo && this.props.plantInfo.constructorId) {
      this.getCstInfo();
    }
  }

  async getCstInfo() {
    const plantInfo = this.props.plantInfo;
    const res = await axios.get(`/cst/api/constructor/${plantInfo.constructorId}`);
    
    this.setState({
      cst: res.data,
      plantInfo: plantInfo,
    });
  }
  formatSize(size) {
    if (size > 1000) {
      return size / 1000;
    }
    return size;
  }

  formatUnit(size) {
    if (size > 1000) {
      return "MWh";
    }
    return "kWh";
  }
  render() {
    const { plantInfo, cst, projectAddr } = this.state;
    const { accumulationPower, t, i18n } = this.props;
    return (
      <PlantCardContainer>
        <h3>{plantInfo.name}</h3>
        <hr />
        <div className='info-wrap'>
          <div className="box">
            <h2 className="tit">{t('key191')}</h2>
            <InfoListBox>
              <p>{t('key192')}: {plantInfo?.installationCapacity || "--"} kW</p>
              <p>
                {`${t('key193')}: `}
                <CountUp
                  start={0}
                  end={this.formatSize(accumulationPower || 0)}
                  decimals={2}
                  duration={3.5}
                  separator=","
                />
                {` ${this.formatUnit(accumulationPower || 0)}`}
              </p>
            </InfoListBox>
          </div>
          <div className="box">
            <h2 className="tit">{t('key194')}</h2>
            <InfoListBox>
              <p>{t('key195')}: {cst.constructorName}</p>
              <p>{t('key196')}: {cst.contactNum}</p>
            </InfoListBox>
          </div>
        </div>
        {/* <dl className="info-wrap">
          <div className='info-item'>
            <dt>설치위치</dt>
            <dd>{projectAddr}</dd>
          </div>
          <div className='info-item'>
            <dt>설비용량</dt>
            <dd>
              <strong className="num">
                {plantInfo.installationCapacity || "00"}
              </strong>
              <strong className="unit"> kW</strong>
            </dd>
          </div>
          <div className="info-item">
            <dt>시공사명</dt>
            <dd>{cst.constructorName}</dd>
          </div>
          <div className="info-item">
            <dt>시공사 연락처</dt>
            <dd>{cst.contactNum}</dd>
          </div>
        </dl> */}
      </PlantCardContainer>
    );
  }
}
const PlantCardContainer = styled.div`
  width: 100%;
  padding: 0 0 12px 0;
  .info-wrap {
    display: flex;
    flex-direction: row;
    gap: 24px;
  }
  .box {
    width: 100%;
  }
  .tit {
    font-size: 18px;
    margin-bottom: 12px;
  }
  & > h3 {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    height: 30px;
  }
  & > hr {
    margin: 12px 0;
  }
  & dt {
    font-weight: 600;
    height: 28px;
    line-height: 28px;
  }
  & dd {
    height: 28px;
    line-height: 28px;
  }
  // .info-wrap {
  //   display: flex;
  //   flex-direction: column;
  //   gap: 5px;
  // }
  .info-item {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }

  strong {
    font-size: 22px;
  }
`;

const InfoListBox = styled.div`
  width: 100%;
  border: 1px solid 1px #e5e6e8;
  background-color: #f2f3f5;
  border-radius: 12px;
  padding: 15px 20px;
  color: #191919;
  p {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 5px;
  }
`;

class StatusLineGraphCard extends Component {
  render() {
    const { t } = this.props;
    const STATUS_DATA = [
      { name: `${t('key197')} 25%`, color: "#ff65cc" },
      { name: `${t('key197')} 50%`, color: "#d63bff" },
      { name: `${t('key197')} 75%`, color: "#a55bff" },
      { name: `${t('key198')} 25%`, color: "#5d129f" },
      { name: `${t('key199')}`, color: "#1c1c1c" },
    ]
    return (
      <StatusLineGraphContainer>
        <GraphWapper>
          <Bar>
            {STATUS_DATA.map((row, index) => (
              <BarItem key={index}>
                {row.name}
              </BarItem>
            ))}
          </Bar>
          <Bar>
            {STATUS_DATA.map((row, index) => (
              <BarItem key={index} bgColor={row.color} />
            ))}
          </Bar>
        </GraphWapper>
      </StatusLineGraphContainer>
    )
  }
}

const StatusLineGraphContainer = styled.div`
  width: 620px;
  height: 114px;
  padding: 32px 20px;
  border: 1px solid #E5E6E8;
  border-radius: 12px;
`;
const GraphWapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Bar = styled.div`
  display: flex;
  flex-direction: row;
  height: 20px;
  border-radius: 10px;
  overflow: hidden;
`;
const BarItem = styled.div`
  width: 20%;
  height: 20px;
  text-align: center;
  color: #595959;
  font-size: 12px;
  ${({ bgColor }) => bgColor && `background-color: ${bgColor};`}
`;

class PannelInfo extends Component {
  
  render() {
    const { 
      selectedModule, 
      status,
      t,
      i18n
    } = this.props;
    return (
      <PannelCardContainer>
        <PannelCard>
          <dl>
            <div className='info-item'>
              <dt>{t('key200')}</dt>
              <dd>{selectedModule?.currentTitle || "-"}</dd>
            </div>
            {/* <div className='info-item'>
              <dt>모듈 온도</dt>
              <dd>{`${selectedModule?.caseTemp?.toFixed(1) || "-"}도씨`}</dd>
            </div> */}
            <div className='info-item'>
              <dt>{t('key201')}</dt>
              <dd>{`${selectedModule?.rate || 0}%`}</dd>
            </div>
          </dl>
        </PannelCard>
        {/* <PannelCard>
          <dl>
            <div className='info-item'>
              <dt>기기 번호</dt>
              <dd>{selectedModule?.currentTitle || "-"}</dd>
            </div>
            <div className='info-item'>
              <dt>기기 온도</dt>
              <dd>{`${selectedModule?.caseTemp?.toFixed(1) || "-"}도씨`}</dd>
            </div>
            <div className='info-item'>
              <dt>발전 온도</dt>
              <dd>{`${selectedModule?.powerStageTemp?.toFixed(1) || "-"}도씨`}</dd>
            </div>
          </dl>
        </PannelCard> */}
        <SelectedPannelInfo color={status} contentWidth={DetailV2SelectedPannelInfoWidth(i18n)}>
            <div className="bottom-row">
              <span className="tit"></span>
              <span className="tit">{t('key202')}</span>
              <span className="tit">{t('key203')}</span>
            </div>
            <div className="divider"/>
            <div className="bottom-row">
              <span className="tit">
                <AutoFitText min={1}>
                  {t('key204')}
                </AutoFitText>
              </span>
              {/* <span>{inputCurrent?.toFixed(2) * -1 || 0}</span> */}
              <span>
                {/* <CountUp
                  start={0}
                  end={selectedModule?.inputCurrent?.toFixed(2) || 0}
                  decimals={2}
                  duration={3.5}
                  separator=","
                /> */}
                {selectedModule?.inputCurrent?.toFixed(2) || 0}
              </span>
              {/* <span>{outputCurrent?.toFixed(2) * -1 || 0}</span> */}
              <span>{selectedModule?.outputCurrent?.toFixed(2) || 0}</span>
            </div>
            <div className="divider"/>
            <div className="bottom-row">
              <span className="tit">
                <AutoFitText min={1}>
                  {t('key205')}
                </AutoFitText>
              </span>
              <span>{selectedModule?.inputVoltage?.toFixed(2) || 0}</span>
              <span>{selectedModule?.outputVoltage?.toFixed(2) || 0}</span>
            </div>
            <div className="divider"/>
            <div className="bottom-row">
              <span className="tit">
                <AutoFitText min={1}>
                  {t('key206')}
                </AutoFitText>
              </span>
              <span>{selectedModule?.inputPower?.toFixed(2) || 0}</span>
              {/* <span>{inputPower?.toFixed(2) * -1 || 0}</span> */}
              <span>{selectedModule?.outputPower?.toFixed(2)|| 0}</span>
              {/* <span>{outputPower?.toFixed(2) * -1 || 0}</span> */}
            </div>
          </SelectedPannelInfo>
      </PannelCardContainer>
    )
  }
}

const SelectedPannelInfo = styled.div`
  border-radius: 8px;
  // ${({ color }) => color ? `background-color: ${color};` : 'background-color: #ffffff;'}
  padding: 0 10px;
  width: 100%;
  border: 1px solid #E5E6E8;
  border-radius: 12px;

  & .tit {
    display: flex;
    align-items: center;
    font-weight: 500;
    height: 25px;
    line-height: 25px;
  }
  & .divider {
    width: 100%;
    height: 1px;
    border-top: 1px solid #E5E6E8;
  }
  & .bottom-row {
    display: flex;
    flex-direction: row;
    align-items-center;
    height: 25px;
    line-height: 25px;
    text-align: center;

    & > :nth-child(1) {
      ${({ contentWidth }) => contentWidth ? `width: ${contentWidth.child1}` : 'width: 60px'}
    }
    & > :nth-child(2) {
      ${({ contentWidth }) => contentWidth ? `width: ${contentWidth.child2}` : 'width: 88px'}
    }
    & > :nth-child(3) {
      ${({ contentWidth }) => contentWidth ? `width: ${contentWidth.child3}` : 'width: 88px'}
    }
  }
`;
const PannelCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
`;

const PannelCard = styled.div`
  padding: 15px 20px;
  border: 1px solid #E5E6E8;
  border-radius: 12px;
  height: 114px;
  width: 100%;
  
  dl {  
    width: 100%
    display: flex;
    flex-direction: column;
  }
  dt, dd {
    height: 28px;
    line-height: 28px;
  }
  .info-item {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
`;

class ModuleCanvasCard extends Component {
  zoomInAndOut = (val) => {
    SCALE_FACTOR = Number(SCALE_FACTOR) + val;
    SCALE_FACTOR = Number(SCALE_FACTOR).toFixed(1);
    let tmWidth = TEMPLATE_WIDTH * SCALE_FACTOR;
    let tmHeight = TEMPLATE_HEIGHT * SCALE_FACTOR;
    this.props.canvas.setZoom(SCALE_FACTOR);
    this.props.canvas.calcOffset();
    this.props.canvas.renderAll();
  };
  render() {
    const { t } = this.props;
    return (
      <TitleWrapper>
        <h4>{t('key207')}</h4>
        <div
          className="card m-map h310"
          style={{ 
            overflow: "scroll", 
            zIndex: 0, 
            // width: "576px"
            width: "100%", 
          }}
        >
          <div className="control-btn">
            <button type="button" onClick={() => this.zoomInAndOut(0.1)}>
              <img src="/images/ctors/map/zoom-in.png" alt={t('key542')} /> 
            </button>
            <button type="button">
              <img src="/images/ctors/map/zoom-reset.png" alt={t('key543')} />
            </button>
            <button type="button" onClick={() => this.zoomInAndOut(-0.1)}>
              <img src="/images/ctors/map/zoom-out.png" alt={t('key544')} />
            </button>
          </div>
          <canvas id="c" width="1000" height="1000"></canvas>
        </div>
      </TitleWrapper>
    )
  }
}

class InverterCurrentPowerCard extends Component {
  render() {
    const { inverters, activeInverterSerialNo, handleActiveModulesByInverter, t, i18n } = this.props;
    return(
      <InverterCurrentPowerContainer labelWidth={DetailV2InverterCurrentPowerCard(i18n).inputLabelWidth}>
        <h3 className="mt-0" style={{ marginBottom: "24px", fontSize: "18px"}}>
          {t('key482')}
          {inverters.length > 1 && (
            <>
              &nbsp;(
              <a onClick={() => handleActiveModulesByInverter("")}>
                {t('key482A')}
              </a>
              )
            </>
          )}
        </h3>
        <div className="inverter-s1-wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "100%"
          }}
        >
          {inverters.map((row, index) => (
            <div
              className={
                row._id == activeInverterSerialNo
                  ? "inverter-s1 active"
                  : "inverter-s1"
              }
              key={index}
              style={{ margin: 0, padding: 0 }}
            >
              <div className="title" style={{ width: "200px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <p className="icon">
                  <img src="/images/ctors/icon/inverter.png" alt="" />
                </p>
                {/*<p className="tit">{`인버터${index+1}`}</p>*/}
                <p className="tit" style={{ width: "128px" }}>
                  <a
                    onClick={() => handleActiveModulesByInverter(row._id)}
                  >{`인버터${index + 1}`}</a>
                </p>
              </div>
              <div className="text">
                <div className="form-inline2">
                  <div className="form-group">
                    <label className="tit">{t('key483')}</label>
                    <input
                      type="text"
                      defaultValue={row.pvVolt}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit">{t('key484')}</label>
                    <input
                      type="text"
                      defaultValue={row.pvCurrent}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    {/* DC 출력 */}
                    <label className="tit">{t('key550')}</label>
                    <input
                      type="text"
                      defaultValue={PS.formatNumber(
                        (row.pvCurrent * row.pvVolt) / 1000
                      )}
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-inline2">
                  <div className="form-group">
                    <label className="tit">{t('key485')}</label>
                    <input
                      type="text"
                      defaultValue={row.lineRVolt}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit">{t('key486')}</label>
                    <input
                      type="text"
                      defaultValue={row.lineRCurrent}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    {/* R상 출력 */}
                    <label className="tit">{t('key551')}</label>
                    <input
                      type="text"
                      defaultValue={PS.formatNumber(
                        (row.lineRCurrent * row.lineRVolt) /
                          Math.sqrt(3) /
                          1000
                      )}
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-inline2">
                  <div className="form-group">
                    <label className="tit">{t('key487')}</label>
                    <input
                      type="text"
                      defaultValue={row.lineSVolt}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit">{t('key488')}</label>
                    <input
                      type="text"
                      defaultValue={row.lineSCurrent}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    {/* S상 출력 */}
                    <label className="tit">{t('key552')}</label>
                    <input
                      type="text"
                      defaultValue={PS.formatNumber(
                        (row.lineSCurrent * row.lineSVolt) /
                          Math.sqrt(3) /
                          1000
                      )}
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-inline2">
                  <div className="form-group">
                    <label className="tit">{t('key489')}</label>
                    <input
                      type="text"
                      defaultValue={row.lineTVolt}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit">{t('key490')}</label>
                    <input
                      type="text"
                      defaultValue={row.lineTCurrent}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    {/* T상 출력 */}
                    <label className="tit">{t("key553")}</label>
                    <input
                      type="text"
                      defaultValue={PS.formatNumber(
                        (row.lineTCurrent * row.lineTVolt) /
                          Math.sqrt(3) /
                          1000
                      )}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </InverterCurrentPowerContainer>
    )
  }
}
const InverterCurrentPowerContainer = styled.div`
  width: 100%;

  .inverter-s1-wrapper .inverter-s1 .form-group .tit {
    ${({ labelWidth }) => labelWidth ? `width: ${labelWidth};` : "width: 60px;"}
  }

  div.text {
    width: 100%;
  }
`;

class AiInfo extends Component {

  render() {
    return (
      <TitleWrapper>
        <h4>AI 정보</h4>
        <AiInfoContentWrapper>
          <AiInfoCard>
            <dt>
              운전 정보
            </dt>
            <dd>
              <span className='color-gray'>상태 변경 가능</span>
              <StatusButton type="warning">
                준비중
              </StatusButton>
            </dd>
          </AiInfoCard>
          <AiInfoCard>
            <dt>
              화재 감지
            </dt>
            <dd>
              <span className='color-gray'>상태 변경 가능</span>
              <StatusButton type="warning">
                준비중
              </StatusButton>
            </dd>
          </AiInfoCard>
          <AiInfoCard>
            <dt>
              화재 발생 횟수
            </dt>
            <dd>
              <span className='value'>{0}</span>
              <span className='unit'>회</span>
            </dd>
          </AiInfoCard>
          <AiInfoCard>
            <dt>
              AI 정보
            </dt>
            <dd>
              <span className='value'>{0}</span>
              <span className='unit'>%</span>
            </dd>
          </AiInfoCard>
          <AiInfoCard>
            <dt>
              AI 정보
            </dt>
            <dd>
              <span className='value'>{0}</span>
              <span className='unit'>%</span>
            </dd>
          </AiInfoCard>
          <AiInfoCard>
            <dt>
              AI 정보
            </dt>
            <dd>
              <span className='value'>{0}</span>
              <span className='unit'>%</span>
            </dd>
          </AiInfoCard>
        </AiInfoContentWrapper>
      </TitleWrapper>
    )
  }
}
const AiInfoContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  width: 100%;
`;
const AiInfoCard = styled.dl`
  width: 100%;
  height: 88px;
  padding: 15px 20px;
  background-color: #F2F3F5;
  border-radius: 12px;

  dt {
    font-size: 15px;
    color: #191919;
    font-weight: 500;
  }
  
  dt, dd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%
    height: 28px;
    line-height: 28px;
  }

  .color-gray {
    color: #8C8C8C;
    font-size: 14px;
  }

  .value {
    font-size: 22px;
    font-weight: 600;
  }
  
  .unit {
    font-size: 18px;
    font-weight: 600;
  }
`;

class IssueInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plantId: this.props.plantId,
      issueList: [],
      issueId: "",
      issueReason: "",
    }
  }

  async getIssue() {
    let res = await axios.get(`/cst/api/plant-issue/detail/${this.state.plantId}/1`);
    this.setState({
        issues: res.data
    })
}

issueClick(issueId) {
    let re = this.state.issues.filter((item) => item.id === issueId);
    this.setState({
        issueId: re[0].id,
        issueReason: re[0].faultCode,
    });
}

async endingIssue() {
    let param = {
        id: CS.$("#issueId"),
        solution: CS.$("#solution")
    }
    let result = await CS.customCreate(`/cst/api/plant-issue/ending`, param, '해당 이슈를 종료하시겠습니까?');
    if(result.isSuccess)
        this.getIssue();
}
  render() {
    const {
      issueList,
      issueId,
      issueReason,
    } = this.state;
    const { t, i18n } = this.props;
    return (
      <TitleWrapper>
        <h4>{t('key210')}</h4>
        <IssueWrapper>
          <CommonContainer>
            {t('key211')}
          </CommonContainer>
          <IssueListContainer>
            {
              issueList && issueList.map((issue, index) => (
                <label key={index} onClick={() => this.issueClick(issue.id)}>
                  {issue.faultCode}
                </label>
              ))
            }
          </IssueListContainer>
          <TitleWithInput labelWidth={DetailV2IssueInputLabel(i18n).width}>
            <input type="hidden" id="issueId" defaultValue={issueId} />
            <span className='tit'>{t('key212')}</span>
            <input type="text" placeholder={t('key213')} defaultValue={issueReason}/>
          </TitleWithInput>
          <TitleWithInput labelWidth={DetailV2IssueInputLabel(i18n).width}>
            <span className='tit'>{t('key214')}</span>
            <input type="text" placeholder={t('key213')} id="solution"/>
          </TitleWithInput>
          <IssueButtonWrapper>
            <button onClick={this.endingIssue}>
              {t('key215')}
            </button>
          </IssueButtonWrapper>
        </IssueWrapper>
      </TitleWrapper>
    )
  }
}
const IssueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const IssueButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;

  button {
    height: 40px;
    padding: 10px 24px;
    background-color: var(--secondary-500);
    border: none;
    border-radius: 5px;
    font-weight: 600;
    color: #ffffff;

    &:hover {
      background-color: #553ace;
    }
  }
`;
const IssueListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;

  & > label {
    width: 100%;
    height: 30px;
    font-size: 14px;
    padding: 0 10px;

    &:hover {
      background-color: #d9d9d9;
    }
  }
`;


class RsdMonitoring extends Component {
  render() {
    const {
      isActive,
    } = this.props;
    return (
      <RsdMonitoringContainer>
        <h4>긴급 차단 모니터링</h4>
        <RsdButton>
          <img src={fireVector} alt="화재불꽃" />
          <span>
            RSD 작동 중
          </span>
        </RsdButton>
      </RsdMonitoringContainer>
    )
  }
}

const RsdMonitoringContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  & > h4 {
    font-size: 18px;
    font-weight: 700;
  }
`;

const RsdButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  width: 500px;
  height: 56px;
  border-radius: 10px;
  border: none;
  background-color: #FF8126;
  box-shadow: 0px 0px 6px 0px #FF6232C2;
  font-weight: 700;
  font-size: 20px;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  color: white;

  & > img {
    width: 24px;
    height: 30px;
  }
`;

class ElectricCircuit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      joinResultGroup: this.props.joinResultGroup,
    }
  }

  async componentDidUpdate() {
    if (this.state.joinResultGroup !== this.props.joinResultGroup) {
      this.setState({
        joinResultGroup: this.props.joinResultGroup,
      })
    }
  }

  render() {
    const { joinResultGroup } = this.state;
    const { selectedModule, t, i18n } = this.props;
    return (
      <TitleWrapper>
        <TitleRow>
          <h4>{t('key208')}</h4>
          {/* <StatusLevel>
            <span className='temp-title'>온도 LEVEL</span>
            <div className='progress'/>
            <div className='row-wrap'>
              <div className='circle-yellow'/>
              <span>점검중</span>
            </div>
            <div className='row-wrap'>
              <div className='circle-blue'/>
              <span>통신 오류</span>
            </div>
          </StatusLevel> */}
        </TitleRow>
        <ElectricCircuitContainer>
          {
            joinResultGroup && joinResultGroup.map((group, index) => (
              <PannelInfoGroupCard group={group} key={index} selectedModule={selectedModule} t={t} i18n={i18n} />
            ))
          }
        </ElectricCircuitContainer>
      </TitleWrapper>
    )
  }
}

const ElectricCircuitContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
const StatusLevel = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  height: 36px;
  padding: 10px;
  border-radius: 12px;
  background-color: #F2F3F5;
  font-size: 12px;
  line-height: 16px;
  box-sizing: border-box;
  transform: translateY(-14px);

  & .temp-title {
    font-weight: 600;
  }

  & .progress {
    position: relative;
    width: 211px;
    height: 16px;
    background: linear-gradient(90deg, #FFFFFF 14.5%, #FF5141 100%);
    border-radius: 8px;
    border: 1px solid #DCDCDC;

    &::before {
      content: "0";
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
    }
    &::after {
      content: "85";
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      color: #FFFFFF;
    }
  }

  & .row-wrap {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;  
  }

  & .circle-yellow {
    width: 16px;
    height: 16px;
    border: 1px solid #DCDCDC;
    border-radius: 50%;
    background-color: #FFEBD8;
  }

  & .circle-blue {
    width: 16px;
    height: 16px;
    border: 1px solid #DCDCDC;
    border-radius: 50%;
    background-color: #DAEBFF;
  }
`;

class PannelInfoGroupCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      group: this.props.group,
      controlCount: 0,
    }

    this.handlePowerOff = this.handlePowerOff.bind(this);
    this.handlePowerOn = this.handlePowerOn.bind(this);
  }

  async handlePowerOff(serialNos) {
    const { t } = this.props;
    MessageBox.confirm(t('key545'), 'Confirm', { // 전원을 끄시겠습니까?
      confirmButtonText: t('key610'), // 예
      cancelButtonText: t('key611'), // 아니오
      type: "info",
    }).then(async () => {
      const param = {
        rtuId: "",
        siteNo: "",
        deviceId: "",
        kind: "23",
        controlKind: "0",
        serialNos,
      }

      const res = await PS.sendMessageToModule(param);

      // if (res && res.resultMsg === 'success') {
        Message({
          type: "success",
          message: t('key546'),  // 전원을 끄는데 성공했습니다.
          iconClass: "success",
        })

        const newGroup = this.state.group.modules;
        serialNos.forEach(serialNo => {
          const module = newGroup.find(module => module.optimonId === serialNo);
          module.state = 20;
        })
        this.setState({
          group: {
            ...this.state.group,
            modules: newGroup,
          }
        })
      // } else {
      //   Message({
      //     type: "info",
      //     message: "전원을 끄는데 실패했습니다.",
      //     iconClass: "cancel",
      //   })
      // }
    }).catch(() => {

      // Message({
      //   type: "info",
      //   message: "전원을 끄는데 실패했습니다.",
      //   iconClass: "cancel",
      // })
    });
  }

  async handlePowerOn(serialNos) {
    const { t } = this.props;
    MessageBox.confirm(t('key547'), 'Confirm', { // 전원을 켜시겠습니까?
      confirmButtonText: t('key610'), // 예
      cancelButtonText: t('key611'), // 아니오
      type: "info",
    }).then(async () => {
      const param = {
        rtuId: "",
        siteNo: "",
        deviceId: "",
        kind: "23",
        controlKind: "2",
        serialNos,
      }

      const res = await PS.sendMessageToModule(param);

      // if (res && res.resultMsg === 'success') {
        Message({
          type: "success",
          message: t('key548'), // 전원을 켜는데 성공했습니다.
          iconClass: "success",
        })
        const newGroup = this.state.group.modules;
        serialNos.forEach(serialNo => {
          const module = newGroup.find(module => module.optimonId === serialNo);
          module.state = 30;
        })

        this.setState({
          group: {
            ...this.state.group,
            modules: newGroup,
          }
        })
      // } else {
      //   Message({
      //     type: "info",
      //     message: "전원을 켜는데 실패했습니다.",
      //     iconClass: "cancel",
      //   })
      // }
    }).catch(() => {
      // Message({
      //   type: "info",
      //   message: "전원을 끄는데 실패했습니다.",
      //   iconClass: "cancel",
      // })
    });
  }
  render() {
    const { group } = this.state;
    const { stringId, inverterIdx, stringIdx, modules } = group;
    const { selectedModule } = this.props;
    let totalPowerState = false;
    modules && modules.forEach(module => {
      if (module.state === 30) {
        totalPowerState = true;
      }
    })
    const serialNos = modules.map(module => module.optimonId);
    const { t, i18n } = this.props;
    const isActiveOptimizerControl = process.env.REACT_APP_DISPLAY_OPTIMIZER_CONTROL === 'true';
    return (
      <PannelInfoGroupCardContainer>
        <div className='tit'>
          {/* ~번 회로 전원 관리 */}
          {`${stringId} ${t('key549')}`}
          {
            isActiveOptimizerControl && (
              <ToggleSwitch 
                isChecked={totalPowerState}
                onClick={() => totalPowerState ? this.handlePowerOff(serialNos) : this.handlePowerOn(serialNos)}
              />
            )
          }
        </div>
        <TransformWrapper 
          defaultScale={1} // 더 넓게 보이도록 기본 스케일을 줄임
          defaultPositionX={0} // 기본 위치를 중앙으로 설정
          defaultPositionY={0}
          zoomAnimation={{ animationTime: 300 }} // 부드러운 줌 애니메이션
        >
          {({ zoomIn, zoomOut, resetTransform, positionX, positionY, ...rest }) => (
            <TransformComponent>
                <div className='content'>
                  {
                    modules && modules.map((moduleItem, index) => (
                      <PannelInfoCard 
                        selectedModule={selectedModule}
                        temp={0} 
                        moduleItem={moduleItem} 
                        key={`${index}-module`} 
                        handlePowerOff={this.handlePowerOff}
                        handlePowerOn={this.handlePowerOn} 
                        t={t}
                        i18n={i18n}
                      />
                    ))
                  }
                </div>
            </TransformComponent>
          )}
        </TransformWrapper>
      </PannelInfoGroupCardContainer>
    )
  }
}
const PannelInfoGroupCardContainer = styled.div`
  width: 1200px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E5E6E8;

  & > .tit {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 48px;
    background-color: #E4E7ED;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
  }

  & .content {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    padding: 15px;
    gap: 5px;
    width: 1200px;

     & > div { /* 그리드 자식 요소 스타일링 */
      width: 100%; /* 그리드 셀의 너비를 부모 그리드 셀에 맞춤 */
      aspect-ratio: 111 / 108; /* 너비 대비 높이를 1.2배로 설정 */
    }
  }
`;

class PannelInfoCard extends Component {
  convertTempToBgColor(temp = 0, status) {
    // 임시 props 점검중, 통신오류 시 해당 color return
    if (status != 30) return 'rgba(213, 217, 225, 1)'; // 작동안함
    if (this.props.state === "error") return `rgba(218, 235, 255, 1)`;
    if (this.props.state === "inMaintenance") return `rgba(255, 235, 216, 1)`;

    const temp0Color = {
      r: 255,
      g: 255,
      b: 255,
      opacity: 1,
    };
    const temp85Color = {
      r: 255,
      g: 81,
      b: 65,
      opacity: 1
    }
    // 클램프 (온도를 0~85 사이로 제한)
    const clampedTemp = Math.max(0, Math.min(85, temp));

    // 온도 비율 (0에서 85 사이)
    const ratio = clampedTemp / 85;

    // 비율에 따른 rgb 계산
    const r = Math.round(temp0Color.r + (temp85Color.r - temp0Color.r) * ratio);
    const g = Math.round(temp0Color.g + (temp85Color.g - temp0Color.g) * ratio);
    const b = Math.round(temp0Color.b + (temp85Color.b - temp0Color.b) * ratio);
    const opacity = temp0Color.opacity + (temp85Color.opacity - temp0Color.opacity) * ratio;

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  render() {
    // 임시 props
    const { temp, moduleItem, handlePowerOn, handlePowerOff, selectedModule, t, i18n } = this.props;
    const { 
      title,
      inputCurrent,
      inputVoltage,
      inputPower,
      outputCurrent,
      outputVoltage,
      outputPower,
      state,
      powerStageTemp,
      optimonId
    } = moduleItem;
    const isActiveOptimizerControl = process.env.REACT_APP_DISPLAY_OPTIMIZER_CONTROL === 'true';
    return (
      <TransformContainer>
        <PannelInfoCardContainer isSelectedModule={title === selectedModule?.currentTitle}>
          <PannelInfoCardWrapper>
            <div className='top-row'>
              <span className='tit'>{title}</span>
              {isActiveOptimizerControl && (
                <ToggleSwitch
                  isChecked={state === 30}
                  // onClick={() => console.log("click")}
                  onClick={() => state === 30 ? handlePowerOff([optimonId]) : handlePowerOn([optimonId])}
                />
              )}
            </div>
            <div className='divider'/>
            <div className='top-row'>
              <span className='tit'>{t('key476')}</span>
              <span>{powerStageTemp?.toFixed(2)}</span>
            </div>
          </PannelInfoCardWrapper>
          <PannelInfoBottomWrapper color={this.convertTempToBgColor(powerStageTemp?.toFixed(2), state)} cellWidth={DetailV2PannelInfoCardWidth(i18n)}>
            <div className="bottom-row">
              <span className="tit"></span>
              <span className="tit">
                <AutoFitText min={4}>
                  {t('key477')}
                </AutoFitText>
              </span>
              <span className="tit">
                <AutoFitText min={4}>
                  {t('key478')}
                </AutoFitText>
              </span>
            </div>
            <div className="divider"/>
            <div className="bottom-row">
              <span className="tit">
                <AutoFitText min={4}>
                  {t('key479')}
                </AutoFitText>
              </span>
              {/* <span>{inputCurrent?.toFixed(2) * -1 || 0}</span> */}
              <span>{inputCurrent?.toFixed(2) || 0}</span>
              {/* <span>{outputCurrent?.toFixed(2) * -1 || 0}</span> */}
              <span>{outputCurrent?.toFixed(2) || 0}</span>
            </div>
            <div className="divider"/>
            <div className="bottom-row">
              <span className="tit">
                <AutoFitText min={4}>
                  {t('key480')}
                </AutoFitText>
              </span>
              <span>{inputVoltage?.toFixed(2) || 0}</span>
              <span>{outputVoltage?.toFixed(2) || 0}</span>
            </div>
            <div className="divider"/>
            <div className="bottom-row">
              <span className="tit">
                <AutoFitText min={4}>
                  {t('key481')}
                </AutoFitText>
              </span>
              <span>{inputPower?.toFixed(2) || 0}</span>
              {/* <span>{inputPower?.toFixed(2) * -1 || 0}</span> */}
              <span>{outputPower?.toFixed(2)|| 0}</span>
              {/* <span>{outputPower?.toFixed(2) * -1 || 0}</span> */}
            </div>
          </PannelInfoBottomWrapper>
        </PannelInfoCardContainer>
      </TransformContainer>
    )
  }
}

// 기존 4column 기준으로 작성되었으나 10Column으로 변경하기 위해 그리드에 적용될 
// 컨테이너 추가
const TransformContainer = styled.div` 
  position: relative;
  width: 100%;
`;

// 기존 width가 하드코딩된 스타일을 10column에 맞추기 위해 scale 조정
const PannelInfoCardContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background-color: #F2F3F5;
  border: 1px solid #E5E6E8;
  border-radius: 12px;
  transform: scale(0.4);
  transform-origin: top left; 
    ${({ isSelectedModule }) => {
    return isSelectedModule ? `
      box-shadow: 2px 2px 15px rgba(98, 70, 228, 0.8);
    ` : '';
  }}
`;
const PannelInfoCardWrapper = styled.div`
  border-radius: 8px;
  background-color: #ffffff;
  padding: 10px 15px;

  & .tit {
    font-weight: 600;
  }
  & .divider {
    width: 100%;
    height: 1px;
    border-top: 1px solid #8C8C8C;
  }
  & .top-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 28px;
    line-height: 28px;

    &:first-child {
      margin-bottom: 10px;
    }
  }
  & .bottom-row {
    display: flex;
    flex-direction: row;
    align-items-center;
    height: 32px;
    line-height: 32px;
    text-align: center;

    & > :nth-child(1) {
      width: 50px;
    }
    & > :nth-child(2) {
      width: 88px;
    }
    & > :nth-child(3) {
      width: 88px;
    }
  }
`;
const PannelInfoBottomWrapper = styled.div`
  border-radius: 8px;
  ${({ color }) => color ? `background-color: ${color};` : 'background-color: #ffffff;'}
  padding: 10px 15px;

  & .tit {
    display: flex;
    align-items: center;
    font-weight: 600;
  }
  & .divider {
    width: 100%;
    height: 1px;
    border-top: 1px solid #8C8C8C;
  }
  & .bottom-row {
    display: flex;
    flex-direction: row;
    align-items-center;
    height: 32px;
    line-height: 32px;
    text-align: center;

    & > :nth-child(1) {
      ${({ cellWidth }) => cellWidth && `width: ${cellWidth.child1};`}
    }
    & > :nth-child(2) {
      ${({ cellWidth }) => cellWidth && `width: ${cellWidth.child2};`}
    }
    & > :nth-child(3) {
      ${({ cellWidth }) => cellWidth && `width: ${cellWidth.child3};`}
    }
  }
`;

export default withTranslation()(DetailV2);

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const CommonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  gap: 10px;
  background-color: #F2F3F5;
  border-radius: 12px;
`;
const TitleWithInput = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;

  .tit {
    ${({ labelWidth }) => labelWidth ? `width: ${labelWidth};` : 'width: 26px;'}
    font-weight: 600;
    font-size: 14px;
    margin: 0 12px 0 20px;
  }

  input {
    width: 100%;
    height: 40px;
    padding: 9px 12px;
    border: 1px solid #D5D8DE;
    border-radius: 4px;
  }
`;

const Divider = styled.hr`
  border: 0;
  border-bottom: 1px solid #333333;
  margin: 0;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  & h4 {
    font-size: 18px;
    font-weight: 700;
    height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
  }
`;

const ItemContainer = styled.div`
  display: grid;
  ${({ gridFr }) => gridFr && `grid-template-columns: ${gridFr};`}
  width: 100%;
  padding: 12px 0;
  gap: 24px;
`;